module.exports = __webpack_public_path__ + "static/img/marke06.3ca8465.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marke06.jpg
// module id = bHVX
// module chunks = 0